import {AfterViewInit, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {IMasterCustomer} from '../../../../views/oes/interfaces/IMasterCustomer';
import {MasterCustomerService} from '../../../../views/oes/services/master-customer.service';
import {AuthService} from '../../../../auth/auth.service';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {WorkspaceService} from '../../../../views/oes/services/workspace.service';
import {Subscription} from 'rxjs/Subscription';
import {MAT_DIALOG_DATA} from '@angular/material';
import {MOesWorkspaceService} from '../../services/m-oes-workspace.service';

@Component({
    selector: 'app-m-oes-workspace-selector',
    templateUrl: './m-oes-workspace-selector.component.html',
    styleUrls: ['./m-oes-workspace-selector.component.scss'],
    providers: [
        WorkspaceService,
        AuthService
    ]
})
export class MOesWorkspaceSelectorComponent implements OnInit, AfterViewInit, OnDestroy {

    public loading: boolean;
    public masterCustomers: Array<IMasterCustomer>;
    public masterCustomerID: any;

    private lastFetched: Date;
    private subscription: Subscription;
    private mobileWorkspaceService: MOesWorkspaceService;

    constructor(
        private masterCustomerService: MasterCustomerService,
        private authService: AuthService,
        private router: Router,
        private toast: ToastrService,
        private workspaceService: WorkspaceService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.masterCustomerID = 0;
    }

    ngOnInit() {
        this.loading = false;
        this.masterCustomers = [];
        this.mobileWorkspaceService = MOesWorkspaceService.getInstance();

        this.lastFetched = new Date();
        this.getData();
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    ngAfterViewInit() {
        this.setInitialValue();
    }

    protected setInitialValue() {
        this.masterCustomerID = this.authService.workspaceMasterCustomerID;
    }

    fetchFreshData() {
        const gap = (new Date()).getTime() - this.lastFetched.getTime();
        if (gap > 600000 || (gap > 60000 && this.masterCustomers.length === 0)) { // 10 minutes OR 1 minute with no data in it
            this.getData();
        }
    }

    getData() {
        this.loading = true;
        this.subscription = this.masterCustomerService.getDataListForSelection({}).subscribe(result => {
            this.lastFetched = new Date();
            this.masterCustomers = result.data;
            this.loading = false;
            const matchingIndex = this.masterCustomers.findIndex(
                masterCustomer => Number(masterCustomer.CU0_ID) === Number(this.authService.workspaceMasterCustomerID)
            );
            if (this.masterCustomers.length < 1 ||  matchingIndex < 0) {
                this.onChangeMasterCustomer(null, false);
            } else {
                this.workspaceService.setWorkspaceMasterCustomer({
                    CU0_ID: this.masterCustomers[matchingIndex].CU0_ID,
                    CU0_ALLOW_INVENTORY_MANAGEMENT: this.masterCustomers[matchingIndex].CU0_ALLOW_INVENTORY_MANAGEMENT
                });
                this.workspaceService.next({});
                this.mobileWorkspaceService.setInventoryManagement(
                    Number(this.masterCustomers[matchingIndex].CU0_ALLOW_INVENTORY_MANAGEMENT) === 1
                );
            }
        }, () => {
            this.loading = false;
        });
    }

    onChangeMasterCustomer(CU0_ID, navigateToMasterData = true) {
        this.authService.setWorkspaceMasterCustomerID(CU0_ID);
        this.masterCustomerService.setSelectedMasterCustomer(CU0_ID).subscribe(result => {
            if (result.success) {
                this.workspaceService.setWorkspaceMasterCustomer(result.masterCustomer);
                this.mobileWorkspaceService.setInventoryManagement(result.masterCustomer.CU0_ALLOW_INVENTORY_MANAGEMENT === 1);
                this.workspaceService.next({});
                if (navigateToMasterData) {
                    this.router.navigate(['/mobile/dashboard'], {skipLocationChange: false}).then(() => {
                        this.router.navigate(['/mobile/oes/master-data']);
                    });
                }
            } else {
                this.toast.error('Failed to save Workspace preference.', 'Error');
                this.workspaceService.setWorkspaceMasterCustomer({CU0_ID: 0, CU0_ALLOW_INVENTORY_MANAGEMENT: 0});
                this.mobileWorkspaceService.setInventoryManagement(false);
                this.workspaceService.next({});
            }
        }, () => {
            this.toast.error('Unable to save Workspace preference.', 'Service Error');
        });
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/modules/mobile/components/oes-workspace-selector/m-oes-workspace-selector.component.ts